const isOrIsNotOperators = [
  {
    name: 'is',
    value: 'is',
  },
  {
    name: 'is not',
    value: 'is_not',
  },
]

const containDoNotContainOperators = [
  {
    name: 'contain',
    value: 'contain',
  },
  {
    name: 'do not contain',
    value: 'do_not_contain',
  },
]

const containsDoesNotContainOperators = [
  {
    name: 'contains',
    value: 'contains',
  },
  {
    name: 'does not contain',
    value: 'does_not_contain',
  },
]

const startsWithEndsWithOperators = [
  {
    name: 'starts with',
    value: 'starts_with',
  },
  {
    name: 'ends with',
    value: 'ends_with',
  },
]

const matchesOperator = [
  {
    name: 'matches',
    value: 'matches',
  },
]

const textOperators = [
  ...isOrIsNotOperators,
  ...containsDoesNotContainOperators,
  ...matchesOperator,
]

const textAndPartialTextOperators = [
  ...isOrIsNotOperators,
  ...containsDoesNotContainOperators,
  ...startsWithEndsWithOperators,
  ...matchesOperator,
]

const contactNameOperators = [
  ...isOrIsNotOperators,
  ...containsDoesNotContainOperators,
  ...startsWithEndsWithOperators,
]

const numberOperators = [
  ...isOrIsNotOperators,
  {
    name: 'less than',
    value: 'lt',
  },
  {
    name: 'less than or equal',
    value: 'lteq',
  },
  {
    name: 'greater than',
    value: 'gt',
  },
  {
    name: 'greater than or equal',
    value: 'gteq',
  },
]

const tagsOperators = [...isOrIsNotOperators, ...containDoNotContainOperators]

export const ruleConditions = {
  parameters: [
    {
      name: 'To email',
      value: 'to_email',
    },
    {
      name: 'From email',
      value: 'from_email',
    },
    {
      name: 'Subject',
      value: 'subject',
    },
    {
      name: 'Description',
      value: 'description',
    },
    {
      name: 'Subject or description',
      value: 'subject_or_description',
    },
    {
      name: 'Contact name',
      value: 'contact_name',
    },
    {
      name: 'Tags',
      value: 'labels',
    },
    {
      name: app.t('Mailbox'),
      value: 'mailbox',
    },
    {
      name: 'Channel',
      value: 'channel',
    },
    {
      name: 'Status',
      value: 'status',
    },
    {
      name: 'Priority',
      value: 'priority',
    },
  ],
  param_operators: {
    to_email: textOperators,
    from_email: textOperators,
    subject: textAndPartialTextOperators,
    description: textAndPartialTextOperators,
    subject_or_description: textAndPartialTextOperators,
    contact_name: contactNameOperators,
    labels: tagsOperators,
    mailbox: isOrIsNotOperators,
    channel: isOrIsNotOperators,
    status: numberOperators,
    priority: numberOperators,
  },
  values: {
    to_email: '',
    from_email: '',
    subject: '',
    description: '',
    subject_or_description: '',
    contact_name: '',
    labels: '',
    priority: [
      {
        name: 'Low',
        value: 'low',
      },
      {
        name: 'Medium',
        value: 'medium',
      },
      {
        name: 'High',
        value: 'high',
      },
      {
        name: 'Urgent',
        value: 'urgent',
      },
    ],
    status: [
      {
        name: 'Unread',
        value: 'unread',
        disabled: false,
      },
      {
        name: 'Opened',
        value: 'opened',
        disabled: false,
      },
      {
        name: 'Closed',
        value: 'closed',
        disabled: false,
      },
      {
        name: 'Spam',
        value: 'spam',
        disabled: false,
      },
    ],
    channel: [
      {
        name: 'Widget',
        value: 'Widget',
      },
      {
        name: 'Facebook',
        value: 'Facebook',
      },
      {
        name: 'Twitter',
        value: 'Twitter',
      },
      {
        name: 'Chat',
        value: 'Chat',
      },
      {
        name: 'Email',
        value: 'Email',
      },
    ],
    mailbox: { valueType: 'Mailbox' },
  },
}

const ruleActions = isPaidAccount => {
  const parameters = [
    {
      name: 'Set Priority as',
      value: 'priority',
    },
    {
      name: 'Set Starred as',
      value: 'star',
    },
    {
      name: 'Set State as',
      value: 'status',
    },
    {
      name: `Set ${app.t('Mailbox')}`,
      value: 'mailbox',
    },
    {
      name: `Assign to ${app.t('Agent')}`,
      value: 'assignee_id',
    },
    {
      name: `Assign to Available ${app.t('Agent')}`,
      value: 'next_available_agent',
    },
    {
      name: `Assign to ${app.t('Group')}`,
      value: 'assignee_group_id',
    },
    {
      name: `Assign to Available ${app.t('Agent')} in ${app.t('Group')}`,
      value: 'next_available_agent_in_group',
    },
    {
      name: 'Add tag',
      value: 'label',
    },
    {
      name: 'Set Snooze',
      value: 'snooze_until',
    },
    {
      name: 'Add Follower',
      value: 'add_agent_as_follower',
    },
  ]

  if (isPaidAccount) {
    parameters.push({
      name: `Send Email to ${app.t('Agent')}`,
      value: 'send_email_to_agent',
    })

    parameters.push({
      name: 'Send Email to Enduser',
      value: 'send_email_to_requester',
    })
  }

  const values = {
    star: {
      dataType: 'LIST',
      options: [
        {
          name: 'True',
          value: '4000',
        },
        {
          name: 'False',
          value: '1000',
        },
      ],
    },
    priority: {
      dataType: 'LIST',
      options: [
        {
          name: 'Low',
          value: '1000',
        },
        {
          name: 'Medium',
          value: '2000',
        },
        {
          name: 'High',
          value: '3000',
        },
        {
          name: 'Urgent',
          value: '4000',
        },
      ],
    },
    subject: { dataType: 'TEXT' },
    subject_or_description: { dataType: 'TEXT' },
    label: { dataType: 'TAGS' },
    next_available_agent: { dataType: null },
    status: {
      dataType: 'LIST',
      options: [
        {
          name: 'Opened',
          value: 'opened',
          disabled: false,
        },
        {
          name: 'Closed',
          value: 'closed',
          disabled: false,
        },
        {
          name: 'Spam',
          value: 'spam',
          disabled: false,
        },
      ],
    },
    channel: {
      dataType: 'LIST',
      options: [
        {
          name: 'Widget',
          value: 'Widget',
        },
        {
          name: 'Facebook',
          value: 'Facebook',
        },
        {
          name: 'Twitter',
          value: 'Twitter',
        },
        {
          name: 'Chat',
          value: 'Chat',
        },
        {
          name: 'Email',
          value: 'Email',
        },
      ],
    },
    snooze_until: {
      dataType: 'LIST',
      options: [
        {
          name: '4 hours',
          value: '14400',
        },
        {
          name: '2 days',
          value: '172800',
        },
        {
          name: '4 days',
          value: '345600',
        },
        {
          name: '1 week',
          value: '604800',
        },
        {
          name: '2 weeks',
          value: '1209600',
        },
        {
          name: '1 month',
          value: '2592000',
        },
        {
          name: 'Indefinitely',
          value: 'indefinitely',
        },
      ],
    },
    mailbox: { dataType: 'LIST', valueType: 'Mailbox' },
    assignee_id: { dataType: 'LIST', valueType: 'Agent' },
    assignee_group_id: { dataType: 'LIST', valueType: 'Group' },
    next_available_agent_in_group: { dataType: 'LIST', valueType: 'Group' },
    add_agent_as_follower: { dataType: 'LIST', valueType: 'Agent' },
    send_email_to_agent: { dataType: 'MessageTemplate', valueType: 'Agent' },
    send_email_to_requester: { dataType: 'MessageTemplate' },
  }

  return {
    parameters,
    values,
  }
}

export const ruleActionsForPaid = {
  ...ruleActions(true),
}

export const ruleActionsForUnpaid = {
  ...ruleActions(false),
}
